export const VideoPlayer = (function () {
  const eventVideoStart = 'PlayVideo';
  const eventVideoClose = 'CloseVideoModal';

  return {
    dispatchVideoStart,
    dispatchVideoClose,
    eventVideoStart,
    eventVideoClose,
  };

  function dispatchVideoStart(video: object, videoIndex?: number) {
    const e = new CustomEvent(eventVideoStart, {
      detail: { video, videoIndex }, // Optional additional data
    });

    document.dispatchEvent(e);
  }

  function dispatchVideoClose() {
    const e = new CustomEvent(eventVideoClose);

    document.dispatchEvent(e);
  }
})();
